import styled from 'styled-components';
import { TextBold, TextMedium } from './../../../styles/GlobalStyledComponents';
import {
  CardColumn,
  CardInput,
  CardRow,
  CardSection,
  InitialAmountBox,
} from '../CardsStyledComponents';

interface CardInputPromotionProps {
  $coStyles?: boolean;
  $marginBottom?: string; 
}

export const CardInputPromotion = styled(CardInput)<CardInputPromotionProps>`
  flex-direction: column;
  padding: 0;
  gap: 0px;
  margin-bottom: ${(props => props.$marginBottom && props.$marginBottom)}; // ACT 10px y CO 0px, pero 5px en el caso de las promociones
`;

interface CardRowSectionOneProps {
  $paddingBottom?: boolean;
}

export const CardRowSectionOne = styled(CardRow)<CardRowSectionOneProps>`
  padding: ${(props: CardRowSectionOneProps) => props.$paddingBottom ? '24px' : '24px 24px 0'};
  gap: 10px;

  @media (max-width: 650px) {
    padding: ${(props: CardRowSectionOneProps) => props.$paddingBottom ? '15px' : '15px 15px 0'};
  }
`;

export const CardRowSectionTwo = styled(CardRow)`
  padding-bottom: 0px;
`;

export const CardSectionColumn = styled(CardColumn)<CardInputPromotionProps>`
  gap: ${(props) => props.$coStyles ? '0px' : '4px'};


`;

interface WatchInformationProps {
  open?: boolean;
}

export const IconPositionInformation = styled.p`
  display: flex;
  align-items: center;
`;

export const WatchInformation = styled(TextMedium)<WatchInformationProps>`
  cursor: pointer;
`;

export const Information = styled(CardSection)`
  gap: 5px;
  margin: 10px 0;
`;

export const MoreInformationButton = styled(Information)`
  border-radius: 32px;
  margin-top: 0px;
  background-color: ${(props) => props.theme.colors.gray12};
  padding: 6px 10px;
`;

export const ShowInformation = styled.div`
  width: 100%;
`;

export const InformationPayments = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const InformationRow = styled(CardRow)`
  margin: 5px 0;
  @media (max-width: 650px) {
    flex-direction: row;
  }
`;

export const PaymentsTypes = styled(CardColumn)`
  width: 100%;
`;

export const InformationLine = styled.hr`
  width: 100%;
  border: none;
  color: ${(props) => props.theme.colors.gray11};
  background-color: ${(props) => props.theme.colors.gray11};
  height: 2px;
  margin: 5px 0;
`;

export const PromotionIconSection = styled(CardSection)`
  @media (max-width: 650px) {
    align-items: flex-start;
  }
`;

export const CardAmountRow = styled(CardRow)`
  margin-top: 8px;

  @media (max-width: 420px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
`;

export const PromotionDetailsRow = styled(CardRow)`
  background-color: ${(props) => props.theme.colors.gray12};
  padding: 24px 16px;
  border-radius: 0 0 16px 16px;
  margin-bottom: 0px;
`;

export const PromotionDetailsSection = styled(CardSection)`
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`;

export const InformationRowGreen = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  background-color: ${(props) => props.theme.colors.green10};
  border-radius: 8px;
  padding: 8px;
`;

export const ExpensesAmount = styled(TextBold)`
  text-decoration: line-through;
`;

export const OriginalAmountBox = styled(InitialAmountBox)`
  padding: 0px 4px 4px 0px;
`;